<div class="uploaded-files-container" *ngIf="files.length">
  <table class="table uploaded-files-table">
    <thead>
      <tr>
        <th>File Name</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of files">
        <td>{{ file.fileName }}</td>
        <td>
          <span class="status-badge" [ngClass]="{
            'status-pending': file.uploadStatus === 'PENDING',
            'status-failed': file.uploadStatus === 'ERROR' || file.uploadStatus === 'FAILED',
            'status-successful': file.uploadStatus === 'SUCCESS'
          }">
            {{ file.uploadStatus }}
          </span>
        </td>
        <td>
          <a *ngIf="file.uploadStatus === 'ERROR' && file.validationErrorFilePath" class="download-link" (click)="onDownloadReport(file)">
            Download Error Report
          </a>
          <span *ngIf="file.uploadStatus === 'ERROR' && !file.validationErrorFilePath && file.errorMessage" class="no-action">{{file.errorMessage}}</span>
          <span *ngIf="file.uploadStatus !== 'ERROR'" class="no-action">-</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
